module.exports = __webpack_public_path__ + "img/hearbeat@3x.7e04d850.png";